<div
  class="min-h-screen w-full bg-[url('/images/the-godfather.webp')] bg-cover bg-center bg-no-repeat bg-black/80 dark:bg-black/85 bg-blend-color text-base-content">
  <div class="container flex justify-center items-center min-h-screen flex-col">
    <!-- header-sec  -->
    <h1
      class="font-bold font-heading text-balance text-center text-3xl md:text-4xl mb-3 bg-linear-to-r from-primary to-secondary bg-clip-text text-transparent text-shadow-sm">
      Enter The Club
    </h1>
    <!-- login form  -->
    <form [formGroup]="loginForm"
      class="py-6 px-6 md:px-12 bg-base-100 rounded-lg border-t-[3px] border-accent-content shadow-sm shadow-secondary w-full max-w-[440px]">
      <!-- logo -->
      <a routerLink="/home" class="block mb-5 text-center cursor-pointer w-full max-w-24 mx-auto">
        <img src="/logos/Blockbuster-darkMode.png" alt="Logo" class="w-16 hidden dark:inline aspect-square" />
        <img src="/logos/Blockbuster-lightMode.png" alt="Logo" class="w-16 dark:hidden aspect-square" />
      </a>

      <!-- email  -->
      <div class="email-sec w-full">
        <label class="input bg-transparent w-full duration-200 hover:border-accent focus:outline-secondary input-secondary">
          <svg class="h-[1em] opacity-50 w-[1em]" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
            viewBox="0 0 24 24" width="20" height="20">
            <path
              d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4zm2 0v.01L12 13l8-8.99V4H4zm16 2.83l-8 8-8-8V20h16V6.83z" />
          </svg>
          <input formControlName="email" type="email" required placeholder="Email"
            class="text-lg placeholder:text-gray-500 placeholder:text-md ps-1 text-base-content" accesskey="m"
            maxlength="30" #email />
        </label>

      </div>

      <!-- password -->
    <div class="pass-sec my-3 w-full relative">
      <label class="input bg-transparent w-full duration-200 hover:border-accent relative focus:outline-secondary input-secondary">
        <svg class="h-[1em] w-[1em] opacity-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <g stroke-linejoin="round" stroke-linecap="round" stroke-width="2.5" fill="none" stroke="currentColor">
            <path
              d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z">
            </path>
            <circle cx="16.5" cy="7.5" r=".5" fill="currentColor"></circle>
          </g>
        </svg>

        <input [type]="showPassword ? 'text' : 'password'" formControlName="password" required placeholder="Password"
          minlength="8" class="text-lg placeholder:text-gray-500 placeholder:text-md ps-1 text-base-content w-full"
          accesskey="p" maxlength="30" #pass />

        <!-- Toggle Eye Icon -->
        <button type="button" (click)="togglePassword()" class="cursor-pointer absolute right-4 top-1/2 -translate-y-1/2 text-xl text-gray-400 hover:text-accent focus:outline-none">
          <ng-container *ngIf="showPassword; else hiddenEye">
            <!-- Eye Icon (visible password) -->
              <ng-icon name="faSolidEye"/>
          </ng-container>
          <ng-template #hiddenEye>
            <!-- Eye-Off Icon (hidden password) -->
            <ng-icon name="faSolidEyeSlash"/>
          </ng-template>
        </button>
      </label>
    </div>


      <!-- Remember Me section -->
      <div class="remember-sec  my-3">
        <div class="inner-container flex justify-start items-center gap-2 ">
          <input type="checkbox" class="checkbox checkbox-accent checkbox-sm" id="remember" accesskey="r"
            formControlName="rememberMe" />
          <label for="remember" class="text-sm cursor-pointer text-base-content">
            Remember Me
          </label>
        </div>

      </div>

      <!-- login-sec  -->
      <div class="btn-sec my-4  w-full">
        <button (click)="loginFun()" [disabled]="state().loading"
          class="text-shadow-lg btn btn-primary w-full bg-gradient-to-r from-primary to-accent/80 shadow-md hover:shadow-accent/80 duration-300 transition-shadow">
          {{state().loading?'Loading...':'Login'}}
        </button>
      </div>

      <!-- navigate to sign in  -->
      <p class="text-sm text-base-content text-center">
        Don't have an account?
        <a routerLink="/register" class="text-accent text-shadow cursor-pointer hover:opacity-70 duration-200">Sign
          Up!</a>
      </p>

      <!-- forget Password Section  -->
      <div class="my-3 text-center">
        <a routerLink="/reset" class="text-accent text-shadow cursor-pointer hover:opacity-70 duration-200">Forget
          Password?</a>
      </div>

    </form>

    <div
      class="shape max-w-[440px] w-full bg-base-200 shadow-2xl h-7 my-3 skew-x-[45deg] translate-y-1 translate-x-2 rounded-md text-white opacity-50">
    </div>
  </div>
</div>
